export default __webpack_public_path__ + "beta-maps-guides-3d-terrain-1200-6cd494b532748dc6eb89bee6093ec911.webp";